<template>
	<div
		v-if="loading"
		class="fixed z-10 bg-black/15 select-none pointer-events-none inset-0 w-screen h-screen flex flex-col items-center justify-center"
	>
		<span class="w-6 h-6 border-[3px] border-l-neutral-400 rounded-full animate-spin" />
	</div>
</template>
<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'

const store = usePaletteBuilderStore()
const { generateNewUrlWithHashPath } = store
const { loading } = storeToRefs(store)

onMounted(() => {
	if (window.location.hash) {
		// legacy 1.0 and 2.0 share url redirect
		const hash = window.location.hash.split('#')[1]
		if (hash) {
			const path = generateNewUrlWithHashPath(hash)
			window.location.href = path
		}
	} else if (window.location.search) {
		// legacy 3.0 share url redirect
		const hash = window.location.search.split('hash=')[1]
		if (hash) {
			const path = generateNewUrlWithHashPath(hash)
			window.location.href = path
		}
	}
})
</script>
